import { Heading2, Heading4 } from '@components/Texts/Texts';
import Hero from '@features/about/Background/Background';
import useWindowWidth from '@hooks/useWindowWidth';
import BaseLayout from '@layouts/Base/BaseLayout';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import { ABOUT_HEADING, ABOUT_TEXT, ABOUT_TITLE, I18N_ABOUT_CONTEXT } from './About.constants';
import { AboutHeading, AboutText, AboutTitle, PageBody } from './About.styles';
import { AboutProps } from './About.types';

const About = ({ user }: AboutProps): JSX.Element => {
  const router = useRouter();
  const width = useWindowWidth();
  const { t } = useTranslation(I18N_ABOUT_CONTEXT);

  return (
    <BaseLayout showFooter headerProps={{ userName: user?.name }} background={<Hero />}>
      <PageBody>
        <AboutTitle>{t(ABOUT_TITLE)}</AboutTitle>
        <AboutHeading as={width > 1023 ? Heading2 : Heading4}>{t(ABOUT_HEADING)}</AboutHeading>
        {Array.from({ length: router.locale === 'ar' ? 3 : 4 }, (_, index) => (
          <AboutText key={index}>{t(ABOUT_TEXT(index + 1))}</AboutText>
        ))}
      </PageBody>
    </BaseLayout>
  );
};

export default About;
